import React from 'react';

import { featuredBrandsFilter } from 'common/api/search/getFeaturedBrands';
import { BaseLandingPage } from '../base/BaseLandingPage';
import { SearchGrid } from 'components/search-grid/SearchGrid';
import { TopPicksCard } from 'features/search/components/TopPicksCard';
import { useSelector } from 'react-redux';
import { FeaturesState } from 'common/features/featuresReducer';
import { useSearchGridStyles } from 'features/search/components/hooks';

export const FeaturedBrands = () => {
    const { pageBrands, loading: brandsLoading } = useSelector(
        (state: FeaturesState) => state.store.searchGrid
    );
    const [searchGridStyles] = useSearchGridStyles<'150', '180'>('150', '180');

    return (
        <BaseLandingPage filter={featuredBrandsFilter} firebaseConfigKey="featured_page_hero_id">
            <SearchGrid
                ItemComponent={TopPicksCard}
                items={pageBrands}
                isLoading={brandsLoading}
                containerStyles={searchGridStyles}
            />
        </BaseLandingPage>
    );
};
